import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import ConfirmDialog from './ConfirmDialog';
import { setConfirmListener } from './confirm';

// Рисует диалоги, запрошенные через nfConfirm(). Портал в body — поверх любой
// открытой формы и вне её маски среза. Enter — подтвердить, Esc — отмена.
function ConfirmHost() {
  const [request, setRequest] = useState(null);
  // Открытый запрос. Новый запрос поверх открытого (двойной клик по подложке и т. п.)
  // закрывает прежний как «Отмена» — иначе его промис не завершился бы никогда.
  const pending = useRef(null);

  useEffect(() => {
    const unsubscribe = setConfirmListener((req) => {
      if (pending.current) pending.current.resolve(false);
      pending.current = req;
      setRequest(req);
    });
    return () => {
      unsubscribe();
      if (pending.current) pending.current.resolve(false);
      pending.current = null;
    };
  }, []);

  const answer = (ok) => {
    if (!request) return;
    request.resolve(ok);
    pending.current = null;
    setRequest(null);
  };

  useEffect(() => {
    if (!request) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); answer(false); }
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); answer(true); }
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request]);

  if (!request) return null;
  return createPortal(
    <ConfirmDialog
      title={request.title || 'Подтвердите действие'}
      message={request.message}
      confirmText={request.confirmText || 'Подтвердить'}
      cancelText={request.cancelText || 'Отмена'}
      variant={request.variant}
      onConfirm={() => answer(true)}
      onCancel={() => answer(false)}
    />,
    document.body
  );
}

export default ConfirmHost;
